import { render, staticRenderFns } from "./PaymentInstructions.vue?vue&type=template&id=a5be10fa&scoped=true"
import script from "./PaymentInstructions.vue?vue&type=script&lang=js"
export * from "./PaymentInstructions.vue?vue&type=script&lang=js"
import style0 from "./PaymentInstructions.vue?vue&type=style&index=0&id=a5be10fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5be10fa",
  null
  
)

export default component.exports